import { BrandLogo } from './BrandLogo';

export { BrandLogo };
